import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Layout from 'web/components/Layout';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
import Featured from './Featured';
import { Helmet } from "react-helmet";
import { postLoadAdvanceSearch, postLoadDropDownSearch, getAllFavoriteAPI, getAllNeedWishlist } from 'redux/actions/postLoad';
import { postInventoryAdvanceSearch, postInventoryDropDownSearch, getAllPostInventoryFavoriteAPI, getAllInventoryWishlist } from 'redux/actions/postInventory';

import Pagination from 'web/components/Pagination';
import PalletsSidebar from 'web/components/PalletsSidebar'
import Breadcrumb from "web/components/Breadcrumb";

import styles from './wisshList.module.scss';

import {
  dashboard
} from 'redux/actions/dashboard';
import { fetchLanguageContentNew } from 'redux/actions/language';


const WishList = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';
  let accountType = localStorage.getItem('accountType')

  let disableFlg = localStorage.getItem('disableFlg')
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const detailsObject = useSelector((state) => state.urlParameters.details);
  const urlObject = useSelector((state) => state.urlParameters.searchPostInventory);
  const [sortState, setSortState] = useState('DESC');

  const token = localStorage.getItem('token');
  const currentLocalization = localStorage.getItem('currentLocalization');
  const [currentPage, setCurrentPage] = useState(1);

  const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });

  const [defaulTitle, setDefaulTitle] = useState('');
  const [postTitle, setPostTitle] = useState('');
  const [getTitle, setTitle] = useState('');
  const [pageType, setPageType] = useState('');
  const [searchTypeQueryparam, setSearchTypeQueryparam] = useState('');
  const [getQueryParams, setQueryParams] = useState();
  const [tabType, setTabType] = useState('');
  const [activePage, setActivePage] = useState();
  const [activeSearch, setActiveSearch] = useState();

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const [expanded, expandedState] = useState();
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      if (!urlObject) {
        setActiveSearch('PostInventory')
        expandedState('sideBar')
      } else {
        setTabType(urlObject && urlObject.tabType)
        setDefaulTitle(urlObject && urlObject.params)
        setActiveSearch(urlObject && urlObject.activeSearch)
        expandedState(urlObject && urlObject.expanded)
      }

      if (accountType === 'Buyer' || accountType === 'Guest') handleSearch('PostInventory', 1, sortState)
      else handleSearch('PostLoad', 1, sortState)

      localStorage.setItem('titleInput', '')
      if (urlObject && urlObject.title) {
        localStorage.setItem('titleInput', urlObject && urlObject.title)
      }

      if (accountType === 'Buyer' || accountType === 'Guest') {
        setPageType('PostInventory')
      } else {
        setPageType('PostLoad')
      }


      if (urlObject && !urlObject.activePage) {
        setActivePage("Active")
      } else {
        if (!urlObject) {
          setActivePage("Active")
        } else {
          setActivePage(urlObject && urlObject.activePage)
        }
      }
    }
  }, []);

  const handleSearch = async (pageType, pageNumber, sortState) => {
    let response;
    let data = {
      pageNumber: pageNumber,
      pageSize: 9,
      sortBy: sortState,
      role: '',
      authId: localStorage.getItem('authId')
    }
    if (pageType === 'PostInventory' || disableFlg === 'true') {              
      response = await dispatch(getAllInventoryWishlist(data, token));
      if (response?.success) {
        if (response?.data && response?.data?.myPostedWishListResponseDTO?.length !== 0) {
          setSearchResponse({ payload: response?.data?.myPostedWishListResponseDTO, title: defaulTitle, totalRecods: response.data.totalElements })
        } else {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
        }
      } else {
        if (response?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    } else {
      response = await dispatch(getAllNeedWishlist(data, token));
      if (response?.success) {
        if (response?.data && response?.data?.myPostedWishListResponseDTO?.length !== 0) {
          setSearchResponse({ payload: response?.data?.myPostedWishListResponseDTO, title: defaulTitle, totalRecods: response.data.totalElements })
        } else {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
        }
      } else {
        if (response?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  }

  const onChangeHandler = (val) => {
    setCurrentPage(1)
    handleSearch(pageType, 1, sortState)
  }

  const onWishListChangeHandler = async (val) => {
    let response;
    let data = {
      pageNumber: 1,
      pageSize: 9,
      sortBy: sortState,
      role: '',
      authId: localStorage.getItem('authId')
    }

    if (val === 'PostInventory' || disableFlg === 'true') {
      response = await dispatch(getAllInventoryWishlist(data, token));
      if (response?.success) {
        if (response?.data && response?.data?.myPostedWishListResponseDTO?.length !== 0) {
          setSearchResponse({ payload: response?.data?.myPostedWishListResponseDTO, title: defaulTitle, totalRecods: response.data.totalElements })
        } else {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
        }
      } else {
        if (response?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    } else {
      response = await dispatch(getAllNeedWishlist(data, token));
      if (response?.success) {
        if (response?.data && response?.data?.myPostedWishListResponseDTO?.length !== 0) {
          setSearchResponse({ payload: response?.data?.myPostedWishListResponseDTO, title: defaulTitle, totalRecods: response.data.totalElements })
        } else {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
        }
      } else {
        if (response?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  }

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
    handleSearch(pageType, pageNumber, sortState)
  }
  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
    },
  ];
  let selectedPage = tabType;
  if (!selectedPage) {
    selectedPage = pageType;
  }
  if (pageType === "PostInventory") {
    selectedPage = pageLanguageContents?.Breadcrumb[2]?.PalletOffers
  } else if (pageType === "PostLoad") {
    selectedPage = pageLanguageContents?.Breadcrumb[1]?.PalletNeeds
  }
  return (
    <>
      <Helmet title="Create and Manage Your Pallet Wish List | PalletTrader" >
        <meta name="description"
          content="Create and manage your wish list for pallets. Keep track of the items you’re waiting for and receive notifications when they become available on our marketplace." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/wish-list" />
      </Helmet>
      {pageType && (
        <Layout
          userType="Buyer"
          selectedSearch={pageType}
          tabType={tabType}
          searchTitle={getTitle}
        >
          {loaderVisible && <Spinner />}
          <div className={styles.homeWrapper}>
            <div className={styles.wrapper}>
              <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected={selectedPage}
                title=""
              />
              {pageType !== "" && (
                <div className={styles.section}>

                  <div className="pd-right-nav">
                    {activePage && <PalletsSidebar expandedPallet={expanded} activePage={activePage} activeSearch={activeSearch} />}
                  </div>
                  <Featured
                    totalRecord={searchResponse.totalRecods}
                    pageType={pageType}
                    response={searchResponse.payload}
                    title=""
                    currentPage={currentPage}
                    tabType={tabType}
                    onChangeHandler={(val) => {
                      setSortState(val)
                      onChangeHandler(val);
                    }}
                    onWishListChangeHandler={(val) => {
                      setPageType(val)
                      onWishListChangeHandler(val);
                    }}
                  />
                </div>
              )}
              {searchResponse.payload.length !== 0 &&
                searchResponse.totalRecods && (
                  <Pagination
                    currentPage={currentPage}
                    totalPage={searchResponse.totalRecods}
                    itemsCountPerPage={9}
                    onPageChange={(value) => {
                      onPageChange(value);
                    }}
                  />
                )}
            </div>
          </div>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
          />
        </Layout>
      )}
    </>
  );
}
export default WishList;